import React, {useEffect, useState} from "react";
import {ERROR_ANIMATION_TIME} from "../../helpers/Constants";
import $ from 'jquery';
import {Alert, Col} from "react-bootstrap";

export default function FlashMessage({ buttons = null, flash = {}, align }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (flash.type) {
      setShow(true)
      $('.flash-messages').fadeOut(ERROR_ANIMATION_TIME).fadeIn(ERROR_ANIMATION_TIME);
    }
  }, [flash])

  return <div className='flash-container'>
    <Col className={`flash-messages ${align === 'center' ? 'p-0' : ''} `}>
      {show && <Alert variant={flash.type} onClose={() => setShow(false)} dismissible>{flash.message}</Alert>}
      {/*{show && <div className={`alert alert-${flash.type}`}>{flash.message}</div>}*/}
    </Col>
    {buttons != null &&
      <Col className='col-auto text-nowrap'>{buttons}</Col>
    }
  </div>;
};
